import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  gridContainer: {
    width: 'auto',
    borderRadius: '30px',
    justifyContent: 'center',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    margin: 0
  },
  gridItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'left'
    }
  },
  iconBackground: {
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(1),
    borderRadius: '50%',
    width: '55px',
    height: '55px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '46px',
      height: '46px'
    }
  },
  icon: {
    width: '30px',
    [theme.breakpoints.down('sm')]: {
      width: '24px'
    }
  },
  iconText: {
    flexGrow: 1,
    fontWeight: 500,
    maxWidth: '280px'
  }
}))
